import req from "@/assets/js/axios"

export default {
    // 获取首页热门成功案例
    getHotCases: (params) => {
        return req.apiAxios('POST', '/cases/CasesController/getHotCases', params)
    },
    // 获取成功案例列表
    getCases: (params) => {
        return req.apiAxios('POST', '/cases/CasesController/getCases', params)
    },
}
